function delphiCompatImageFit() {
    if (!Modernizr.objectfit) {
        $('.card > .card-item > .card-item-image').each(function () {
            var $container = $(this), imgUrl = $container.find('img').prop('src');
            if (imgUrl) {
                $container
                    .css('backgroundImage', 'url(' + imgUrl + ')')
                    .addClass('compat-object-fit');
            }
        });
    }
}
$(document).ready(function () {
    delphiCompatImageFit();
});

//# sourceMappingURL=DelphiImageFit.js.map
